/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 15h11V9H4v6zM18.5 4v16H20V4h-1.5z" />
	</SVG>
);
